import * as GoldenLayout from "golden-layout";

export const BASE_COMPONENT_KEY = "base-component";
export const TEXT_COMPONENT_KEY = "text-component";
export const LISTING_INFORMATION_COMPONENT_KEY =
  "listing-information-component";
export const LISTING_BARCODE_COMPONENT_KEY = "listing-barcode-component";
export const LISTING_QRCODE_COMPONENT_KEY = "listing-qrcode-component";
export const LISTING_IMAGE_COMPONENT_KEY = "listing-image-component";
export const LISTING_TABLE_COMPONENT_KEY = "listing-table-component";

export const DEFAULT_BASE_COMPONENT = {
  type: "component",
  componentName: BASE_COMPONENT_KEY,
  componentState: {
    style: {
      "background-color": "#fff",
    },
  },
};
export const DEFAULT_TEXT_COMPONENT = {
  type: "component",
  componentName: TEXT_COMPONENT_KEY,
  componentState: {
    html: '<span style="font-size: 10px">Write your content</span>',
    style: {
      padding: "1%",
    },
  },
};
export const DEFAULT_LISTING_MAIN_IMAGE_COMPONENT = {
  type: "component",
  componentName: LISTING_IMAGE_COMPONENT_KEY,
  componentState: {
    additional_images_max_rows: 0,
    additional_images_max_columns: 0,
    style: {
      "background-size": "cover",
    },
  },
};

export const DEFAULT_LISTING_IMAGE_COMPONENT = {
  type: "component",
  componentName: LISTING_IMAGE_COMPONENT_KEY,
  componentState: {
    style: {
      "background-size": "cover",
    },
  },
};

export const DEFAULT_SIMPLE_LISTING_INFORMATION_COMPONENT = {
  type: "component",
  componentName: LISTING_INFORMATION_COMPONENT_KEY,
  componentState: {
    html: `<p style=\"line-height: 1.4; text-align: center;\"><strong><span style='font-size: 24px; font-family: \"Open Sans\";'>[TITLE]</span></strong></p>`,
    style: {
      padding: "2%",
    },
  },
};

export const DEFAULT_LISTING_INFORMATION_COMPONENT = {
  type: "component",
  componentName: LISTING_INFORMATION_COMPONENT_KEY,
  componentState: {
    html: `
        <p style="line-height: 1.4;"><strong><span style="font-size: 24px;">[TITLE]&nbsp;</span></strong><span style="font-size: 24px;">[PRICE]</span></p>
        <div style="line-height: 1.4;"><span style="color: rgb(119, 119, 119);"><em>sku: [SKU]</em></span></div>
        
        <p><span style="color: rgb(119, 119, 119);"></span></p><br>
        <div style="line-height: 1.4;"><strong><em>Options available:</em></strong> [VARIANTS(TITLE, SKU, PRICE)]</div>
        <br><br>
        
        <p style="line-height: 1.3;">[DESCRIPTION]</p>
        `,
    style: {
      padding: "2%",
    },
  },
};

export const DEFAULT_LISTING_TABLE_COMPONENT = {
  type: "component",
  componentName: LISTING_TABLE_COMPONENT_KEY,
  componentState: {
    max_rows: 15,
    columns: [
      {
        header_html: "",
        content_html: "[MAIN_IMAGE]",
        style: {
          width: "10%",
          "border-bottom-width": "thin",
          "border-top-width": "thin",
          "border-left-width": "thin",
          "border-right-width": "thin",
          "border-left-color": "#cccccc",
          "border-right-color": "#cccccc",
          "border-top-color": "#cccccc",
          "border-bottom-color": "#cccccc",
        },
      },
      {
        header_html:
          '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Title</span>',
        content_html: '<span style="font-size: 10px;">[SKU] - [TITLE]</span>',
        style: {
          width: "60%",
          "border-bottom-width": "thin",
          "border-top-width": "thin",
          "border-left-width": "thin",
          "border-right-width": "thin",
          "border-left-color": "#cccccc",
          "border-right-color": "#cccccc",
          "border-top-color": "#cccccc",
          "border-bottom-color": "#cccccc",
        },
      },
      {
        header_html:
          '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Price</span>',
        content_html: '<span style="font-size: 10px;">[PRICE]</span>',
        style: {
          width: "10%",
          "border-bottom-width": "thin",
          "border-top-width": "thin",
          "border-left-width": "thin",
          "border-right-width": "thin",
          "border-left-color": "#cccccc",
          "border-right-color": "#cccccc",
          "border-top-color": "#cccccc",
          "border-bottom-color": "#cccccc",
        },
      },
      {
        header_html:
          '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Quantity</span>',
        content_html: "",
        style: {
          width: "10%",
          "border-bottom-width": "thin",
          "border-top-width": "thin",
          "border-left-width": "thin",
          "border-right-width": "thin",
          "border-left-color": "#cccccc",
          "border-right-color": "#cccccc",
          "border-top-color": "#cccccc",
          "border-bottom-color": "#cccccc",
        },
      },
      {
        header_html:
          '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Total</span>',
        content_html: "",
        style: {
          width: "10%",
          "border-bottom-width": "thin",
          "border-top-width": "thin",
          "border-left-width": "thin",
          "border-right-width": "thin",
          "border-left-color": "#cccccc",
          "border-right-color": "#cccccc",
          "border-top-color": "#cccccc",
          "border-bottom-color": "#cccccc",
        },
      },
    ],
    style: {
      padding: "2%",
    },
  },
};

export const DEFAULT_LISTING_BARCODE_COMPONENT = {
  type: "component",
  scale_x: 2,
  scale_y: 2,
  componentName: LISTING_BARCODE_COMPONENT_KEY,
  componentState: {
    display_text: 1,
    type: "code128",
    style: {
      padding: "2%",
    },
  },
};

export const DEFAULT_LISTING_QRCODE_COMPONENT = {
  type: "component",
  componentName: LISTING_QRCODE_COMPONENT_KEY,
  componentState: {
    style: {
      padding: "2%",
    },
  },
};

export const DEFAULT_BARCODE_CONTENT: GoldenLayout.ItemConfigType[] = [
  {
    type: "column",
    isClosable: true,
    title: "",
    content: [
      {
        type: "stack",
        isClosable: true,
        title: "",
        height: 27.83505154639175,
        content: [
          {
            type: "component",
            componentName: "listing-information-component",
            componentState: {
              html: '<p style="line-height: 1.4; text-align: center;"><strong><span style=\'font-size: 24px; font-family: "Open Sans";\'>[TITLE] [VARIANT_OPTION_TITLE]</span></strong></p>',
              style: {
                padding: "2%",
              },
              componentName: "listing-information-component",
              title: "drag",
            },
            isClosable: true,
            title: "listing-information-component",
          },
        ],
      },
      {
        type: "stack",
        isClosable: true,
        title: "",
        height: 72.16494845360823,
        content: [
          {
            type: "component",
            componentName: "listing-barcode-component",
            componentState: {
              display_text: true,
              type: "code128",
              style: {
                padding: "1%",
              },
              componentName: "listing-barcode-component",
              title: "drag",
              scale_x: 6,
            },
            isClosable: true,
            title: "listing-barcode-component",
          },
        ],
      },
    ],
  },
];

export const DEFAULT_INVENTORY_TAG_CONTENT: GoldenLayout.ItemConfigType[] = [
  {
    type: "column",
    isClosable: true,
    title: "",
    width: 99.99999999999999,
    content: [
      {
        type: "row",
        isClosable: true,
        title: "",
        height: 93.78378378378378,
        content: [
          {
            type: "stack",
            isClosable: true,
            title: "",
            width: 3.5426731078904994,
            content: [
              {
                type: "component",
                componentName: "base-component",
                componentState: {
                  style: {
                    "background-color": "#fff",
                    padding: 0,
                  },
                  componentName: "base-component",
                  title: "drag",
                },
                isClosable: true,
                title: "base-component",
              },
              {
                type: "component",
                componentName: "base-component",
                componentState: {
                  style: {
                    "background-color": "#fff",
                    padding: 0,
                  },
                  componentName: "base-component",
                  title: "drag",
                },
                isClosable: true,
                title: "base-component",
              },
              {
                type: "component",
                componentName: "listing-image-component",
                componentState: {
                  additional_images_max_rows: 0,
                  additional_images_max_columns: 0,
                  style: {
                    "background-size": "cover",
                    padding: 0,
                  },
                  componentName: "listing-image-component",
                  title: "drag",
                },
                isClosable: true,
                title: "listing-image-component",
              },
              {
                type: "component",
                componentName: "base-component",
                componentState: {
                  style: {
                    "background-color": "#fff",
                    padding: 0,
                  },
                  componentName: "base-component",
                  title: "drag",
                },
                isClosable: true,
                title: "base-component",
              },
            ],
          },
          {
            type: "column",
            isClosable: true,
            title: "",
            width: 96.4573268921095,
            content: [
              {
                type: "stack",
                isClosable: true,
                title: "",
                height: 6.6473988439306355,
                content: [
                  {
                    type: "component",
                    componentName: "base-component",
                    componentState: {
                      style: {
                        "background-color": "#fff",
                        padding: 0,
                      },
                      componentName: "base-component",
                      title: "drag",
                    },
                    isClosable: true,
                    title: "base-component",
                  },
                ],
              },
              {
                type: "row",
                isClosable: true,
                title: "",
                height: 93.35260115606935,
                content: [
                  {
                    type: "stack",
                    isClosable: true,
                    title: "",
                    width: 50,
                    content: [
                      {
                        type: "component",
                        componentName: "listing-image-component",
                        componentState: {
                          additional_images_max_rows: 0,
                          additional_images_max_columns: 0,
                          style: {
                            "background-size": "contain",
                            padding: "4%",
                          },
                          componentName: "listing-image-component",
                          title: "drag",
                        },
                        isClosable: true,
                        title: "listing-image-component",
                      },
                    ],
                  },
                  {
                    type: "column",
                    isClosable: true,
                    title: "",
                    width: 50,
                    content: [
                      {
                        type: "row",
                        isClosable: true,
                        title: "",
                        height: 24.22360248447205,
                        content: [
                          {
                            type: "stack",
                            isClosable: true,
                            title: "",
                            height: 24.22360248447205,
                            width: 92.58064516129032,
                            content: [
                              {
                                type: "component",
                                componentName: "listing-information-component",
                                componentState: {
                                  html: '<p style="line-height: 1.4; text-align: center;"><br></p><p style="line-height: 1.4; text-align: center;"><strong><span style=\'font-size: 18px; font-family: "Open Sans";\'>[TITLE] [VARIANT_OPTION_TITLE]</span></strong></p>',
                                  style: {
                                    padding: "2%",
                                  },
                                  componentName:
                                    "listing-information-component",
                                  title: "drag",
                                },
                                isClosable: true,
                                title: "listing-information-component",
                              },
                            ],
                          },
                          {
                            type: "stack",
                            isClosable: true,
                            title: "",
                            width: 7.41935483870968,
                            content: [
                              {
                                type: "component",
                                componentName: "base-component",
                                componentState: {
                                  style: {
                                    "background-color": "#fff",
                                    padding: 0,
                                  },
                                  componentName: "base-component",
                                  title: "drag",
                                },
                                isClosable: true,
                                title: "base-component",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        type: "row",
                        isClosable: true,
                        title: "",
                        height: 75.77639751552795,
                        content: [
                          {
                            type: "stack",
                            isClosable: true,
                            title: "",
                            height: 75.77639751552795,
                            width: 92.58064516129032,
                            content: [
                              {
                                type: "component",
                                componentName: "listing-qrcode-component",
                                componentState: {
                                  style: {
                                    padding: "10%",
                                  },
                                  componentName: "listing-qrcode-component",
                                  title: "drag",
                                },
                                isClosable: true,
                                title: "listing-qrcode-component",
                              },
                            ],
                          },
                          {
                            type: "stack",
                            isClosable: true,
                            title: "",
                            width: 7.41935483870968,
                            content: [
                              {
                                type: "component",
                                componentName: "base-component",
                                componentState: {
                                  style: {
                                    "background-color": "#fff",
                                    padding: 0,
                                  },
                                  componentName: "base-component",
                                  title: "drag",
                                },
                                isClosable: true,
                                title: "base-component",
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "stack",
        isClosable: true,
        title: "",
        height: 6.216216216216219,
        content: [
          {
            type: "component",
            componentName: "base-component",
            componentState: {
              style: {
                "background-color": "#fff",
                padding: 0,
              },
              componentName: "base-component",
              title: "drag",
            },
            isClosable: true,
            title: "base-component",
          },
        ],
      },
    ],
  },
];

export const DEFAULT_TEAR_SHEET_CONTENT: GoldenLayout.ItemConfigType[] = [
  {
    type: "column",
    content: [
      {
        type: "column",
        width: 100,
        height: 54.53174187047099,
        content: [
          {
            type: "stack",
            height: 9.493670886075948,
            content: [
              {
                type: "component",
                componentName: "text-component",
                componentState: {
                  html: '<p style="text-align: center;"><span style="font-size: 36px;">[BUSINESS_LOGO]</span></p>',
                  style: {
                    padding: "1%",
                  },
                  componentName: "text-component",
                },
                title: "text-component",
              },
            ],
          },
          {
            width: 43.83408071748879,
            type: "stack",
            height: 90.50632911392402,
            content: [
              {
                title: "listing-image-component",
                componentState: {
                  style: {
                    "background-size": "contain",
                    padding: "2%",
                  },
                  componentName: "listing-image-component",
                  additional_images_max_rows: 4,
                  additional_images_max_columns: 1,
                },
                componentName: "listing-image-component",
                type: "component",
              },
            ],
          },
        ],
      },
      {
        type: "stack",
        height: 41.899863187717884,
        content: [
          {
            type: "component",
            componentName: "listing-information-component",
            componentState: {
              html: `<p style="line-height: 1.4;"><strong><span style="font-size: 18px;">[TITLE]&nbsp;</span></strong><span style="font-size: 18px;">[PRICE]</span></p>
                <div style="line-height: 1.4;"><span style="color: rgb(119, 119, 119);"><em><span style="font-size: 12px;">sku: [SKU]</span></em></span></div>
                
                <p><span style="color: rgb(119, 119, 119);"><em></em></span></p><br><div style="line-height: 1.4;"><strong><em><span style="font-size: 12px;">Options available:</span></em></strong><span style="font-size: 12px;">&nbsp;[VARIANTS(TITLE, SKU, PRICE)]</span></div>
                `,
              style: {
                padding: "4%",
              },
              componentName: "listing-information-component",
            },
          },
        ],
      },
      {
        height: 3.568394941811137,
        type: "stack",
        content: [
          {
            title: "text-component",
            componentState: {
              padding: "5px",
              html: '<p style="text-align: center;"><span style="font-size: 8px;">[BUSINESS_ADDRESS], [BUSINESS_CITY], [BUSINESS_STATE_PROVINCE] [BUSINESS_ZIP_CODE], [BUSINESS_COUNTRY] | [BUSINESS_PHONE_NUMBER] | [BUSINESS_WEBSITE]</span></p>',
              id: 4,
              componentName: "text-component",
              style: {
                padding: "1%",
              },
            },
            componentName: "text-component",
            type: "component",
          },
        ],
      },
    ],
  },
];

export const DEFAULT_ORDER_SHEET_CONTENT: GoldenLayout.ItemConfigType[] = [
  {
    type: "column",
    title: "",
    content: [
      {
        type: "column",
        width: 100,
        height: 96.20733249051833,
        title: "",
        content: [
          {
            type: "stack",
            height: 4.210526315789473,
            title: "",
            content: [
              {
                type: "component",
                componentName: "text-component",
                componentState: {
                  html: '<p style="text-align: center;"><span style="font-size: 36px;">[BUSINESS_LOGO]</span></p>',
                  style: {
                    padding: "1%",
                  },
                  componentName: "text-component",
                  title: "drag",
                },
                title: "text-component",
              },
            ],
          },
          {
            type: "stack",
            title: "",
            height: 95.78947368421049,
            content: [
              {
                type: "component",
                componentName: "listing-table-component",
                componentState: {
                  max_rows: 15,
                  columns: [
                    {
                      header_html: "",
                      content_html: "<p>[MAIN_IMAGE]</p>",
                      style: {
                        width: "7%",
                        "border-bottom-width": "thin",
                        "border-color": "#000000",
                        "border-width": "1px",
                        borders: [
                          "border-left",
                          "border-right",
                          "border-top",
                          "border-bottom",
                        ],
                        "border-left-width": "thin",
                        "border-left-color": "#000000",
                        "border-right-width": "thin",
                        "border-right-color": "#000000",
                        "border-top-width": "thin",
                        "border-top-color": "#000000",
                        "border-bottom-color": "#000000",
                      },
                    },
                    {
                      header_html:
                        '<p><span style="font-size: 12px; font-weight: bold; color: #0e78d2;">Title</span></p>',
                      content_html:
                        '<span style="font-size: 10px;">[SKU] - [TITLE]</span>',
                      style: {
                        width: "45%",
                        "border-bottom-width": "thin",
                        "border-color": "#000000",
                        "border-width": "1px",
                        borders: [
                          "border-left",
                          "border-right",
                          "border-top",
                          "border-bottom",
                        ],
                        "border-left-width": "thin",
                        "border-left-color": "#000000",
                        "border-right-width": "thin",
                        "border-right-color": "#000000",
                        "border-top-width": "thin",
                        "border-top-color": "#000000",
                        "border-bottom-color": "#000000",
                      },
                    },
                    {
                      header_html:
                        '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Price</span>',
                      content_html:
                        '<span style="font-size: 10px;">[PRICE]</span>',
                      style: {
                        width: "10%",
                        "border-bottom-width": "thin",
                        "border-color": "#000000",
                        "border-width": "1px",
                        borders: [
                          "border-left",
                          "border-right",
                          "border-top",
                          "border-bottom",
                        ],
                        "border-left-width": "thin",
                        "border-left-color": "#000000",
                        "border-right-width": "thin",
                        "border-right-color": "#000000",
                        "border-top-width": "thin",
                        "border-top-color": "#000000",
                        "border-bottom-color": "#000000",
                      },
                    },
                    {
                      header_html:
                        '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Quantity</span>',
                      content_html: "",
                      style: {
                        width: "10%",
                        "border-bottom-width": "thin",
                        "border-color": "#000000",
                        "border-width": "1px",
                        borders: [
                          "border-left",
                          "border-right",
                          "border-top",
                          "border-bottom",
                        ],
                        "border-left-width": "thin",
                        "border-left-color": "#000000",
                        "border-right-width": "thin",
                        "border-right-color": "#000000",
                        "border-top-width": "thin",
                        "border-top-color": "#000000",
                        "border-bottom-color": "#000000",
                      },
                    },
                    {
                      header_html:
                        '<span style="font-size: 12px; font-weight: bold; color: #0e78d2">Total</span>',
                      content_html: "",
                      style: {
                        width: "10%",
                        "border-bottom-width": "thin",
                        "border-color": "#000000",
                        "border-width": "1px",
                        borders: [
                          "border-left",
                          "border-right",
                          "border-top",
                          "border-bottom",
                        ],
                        "border-left-width": "thin",
                        "border-left-color": "#000000",
                        "border-right-width": "thin",
                        "border-right-color": "#000000",
                        "border-top-width": "thin",
                        "border-top-color": "#000000",
                        "border-bottom-color": "#000000",
                      },
                    },
                  ],
                  style: {
                    padding: "2%",
                  },
                  componentName: "listing-table-component",
                  title: "drag",
                },
                title: "listing-table-component",
              },
            ],
          },
        ],
      },
      {
        type: "row",
        title: "",
        height: 3.792667509481673,
        content: [
          {
            type: "stack",
            title: "",
            width: 9.014707682453764,
            content: [
              {
                type: "component",
                componentName: "base-component",
                componentState: {
                  style: {
                    "background-color": "#fff",
                    padding: 0,
                  },
                  componentName: "base-component",
                  title: "drag",
                },
                title: "base-component",
              },
            ],
          },
          {
            height: 3.792667509481673,
            type: "stack",
            title: "",
            width: 77.70635776309355,
            content: [
              {
                title: "text-component",
                componentState: {
                  padding: "5px",
                  html: '<p style="text-align: center;"><span style="font-size: 8px;">[BUSINESS_ADDRESS], [BUSINESS_CITY], [BUSINESS_STATE_PROVINCE] [BUSINESS_ZIP_CODE], [BUSINESS_COUNTRY] | [BUSINESS_PHONE_NUMBER] | [BUSINESS_WEBSITE]</span></p>',
                  id: 4,
                  componentName: "text-component",
                  style: {
                    padding: "1%",
                  },
                  title: "drag",
                },
                componentName: "text-component",
                type: "component",
              },
            ],
          },
          {
            type: "stack",
            title: "",
            width: 13.27893455445269,
            content: [
              {
                type: "component",
                componentName: "text-component",
                componentState: {
                  html: '<p style="text-align: center; line-height: 1.8;"><span style="font-size: 8px;">[PAGE_NUMBER]</span></p>',
                  style: {
                    padding: "1%",
                  },
                  componentName: "text-component",
                  title: "drag",
                },
                title: "text-component",
              },
            ],
          },
        ],
      },
    ],
  },
];
